import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const PackageConfirmationWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 85%;
  margin-top: 40px;
`;
